module.exports = __webpack_public_path__ + "static/Hobgoblin-a79350367dd37cabe2a31e0df47568d6.jpg";